function decrementQuantity(quantityId) {
  var quantityInput = document.getElementById(quantityId);
  var currentValue = parseInt(quantityInput.value);
  if (currentValue > 1) {
    quantityInput.value = currentValue - 1;
    // Trigger form submission to update cart
    quantityInput.form.submit();
  }
}

function incrementQuantity(quantityId) {
  var quantityInput = document.getElementById(quantityId);
  quantityInput.value = parseInt(quantityInput.value) + 1;
  // Trigger form submission to update cart
  quantityInput.form.submit();
} 